type Meta = { page?: number; perPage?: number; totalCount?: number; totalPages?: number } | null | undefined

// Defaults a response's pagination meta to the request when the server omits a field.
export function toPageMeta(meta: Meta, page: number, perPage: number, rowCount: number) {
  const effectivePerPage = meta?.perPage ?? perPage
  const totalCount = meta?.totalCount ?? rowCount
  return {
    page: meta?.page ?? page,
    perPage: effectivePerPage,
    totalCount,
    totalPages: meta?.totalPages ?? Math.max(Math.ceil(totalCount / effectivePerPage), 1),
  }
}
